import { UrlSegment, UrlSegmentGroup, Route, UrlMatchResult, UrlMatcher } from "@angular/router";
import { getLoggerFor, logCall, LogLevel } from "@tylertech/logging";

const PATH_SEPARATOR = "/";
const ROUTE_PARAMETER = /^:([^/]+)$/;
const EAGER_ROUTE_PARAMETER = /^:([^/]+)\*$/;


const coreRoutingLogger = getLoggerFor("CoreRoutingModule");
// ? TODO - I moved this because I needed it in a shared spot... but I still don't really like it here...
/**
 * Creates a UrlMatcher function that mimics AngularJs's eager route parameter functionality.
 * @param path
 */
export function createUrlMatcher(path: string): UrlMatcher
{
    coreRoutingLogger
        .debug(`creating urlMatcher function for "${path}"`, { path });

    const pathSegments = path.split(PATH_SEPARATOR);

    const log = coreRoutingLogger.withPrefix(() => `urlMatcher[${path}]`);
    return logCall(
        {
            level: LogLevel.DEBUG,
            logger: log,
            logParamTransforms: [
                _ => `[Array UrlSegment]`,
                _ => `[object UrlSegmentGroup]`,
                _ => `[object Route]`,
            ]
        },
        urlMatcher);

    function urlMatcher(urlSegments: UrlSegment[], _group: UrlSegmentGroup, _route: Route): UrlMatchResult | null
    {
        const consumed: UrlSegment[] = [];
        const routeParameters: { [name: string]: UrlSegment, } = {};
        if (!urlSegments || urlSegments.length < 1)
        {
            log.debug(`no segments specified`);
            return null;
        }

        for (let i = 0; i < pathSegments.length; i++)
        {
            const pathSegment = pathSegments[i];
            const urlSegment = urlSegments[i];

            const eagerRouteParameterMatches = EAGER_ROUTE_PARAMETER.exec(pathSegment);
            if (eagerRouteParameterMatches)
            {
                // consume all remaining urlSegments into a single urlSegment and add to routeParameters. then return...
                const remainingSegments = urlSegments.slice(i); // skip prefix
                const paths = remainingSegments.map(segment => segment.path);
                const merged = paths.join(PATH_SEPARATOR);

                const routeParameterName = eagerRouteParameterMatches[1];
                // NOTE: the parameters arg is for matrix parameters, not query parameters. We do not currently use or support matrix parameters.
                routeParameters[routeParameterName] = new UrlSegment(merged, { /* id: merged */ });

                const eagerRouteResult = {
                    consumed: urlSegments,
                    posParams: routeParameters,
                };
                log.debug(`returning UrlMatchResult with eager route params`, { eagerRouteResult });
                return eagerRouteResult;
            }

            const routeParameterMatches = ROUTE_PARAMETER.exec(pathSegment);
            if (routeParameterMatches)
            {
                const routeParameterName = routeParameterMatches[1];
                routeParameters[routeParameterName] = urlSegment;
            }
            else if (pathSegment === urlSegment.path)
            {
                consumed.push(urlSegment);
            }
            else
            {
                return null;
            }
        }

        const matchResults = {
            consumed: urlSegments,
            posParams: routeParameters,
        };
        log.debug(`returning UrlMatchResult with route params`, { matchResults });
        return matchResults;
    }
}
